import { render, staticRenderFns } from "./VisitValueStep.vue?vue&type=template&id=39579796&scoped=true"
import script from "./VisitValueStep.vue?vue&type=script&lang=ts"
export * from "./VisitValueStep.vue?vue&type=script&lang=ts"
import style0 from "./VisitValueStep.vue?vue&type=style&index=0&id=39579796&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39579796",
  null
  
)

export default component.exports